const initials = "exams/";

export const UPDATE_LEGACY_CANDIDATES = `${initials}UPDATE_LEGACY_CANDIDATES`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;